import React from 'react';
import { motion } from 'framer-motion';
import styles from './Header.module.scss';
import williamsLogo from '../../../assets/william-logo.svg';

/* global APP_CONFIG */

function Header(props){
    return (
      <motion.header className={styles.header} {...props}>
        <h1 className={styles.heading}><em>Drive</em> to <em>Win</em></h1>
        <p className={styles.subheading}>in partnership with <img className={styles.partnerLogo} src={williamsLogo} alt="Williams Racing"/></p>
      </motion.header>
    )
}

export default Header;